import {
  Chip,
  Grid,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import axios from "axios";
import he from "he";
import { useNavigate, useLocation } from "react-router-dom";

export default function ExperiencesFilters({
  page,
  totalPages,
  setCategory,
  setSearchText,
}) {
  const navigate = useNavigate();
  const location = useLocation();

  const [categories, setCategories] = useState([]);
  const [activeCategory, setActiveCategory] = useState(null);
  const [search, setSearch] = useState("");

  // Fetch post categories
  useEffect(() => {
    axios.get(WP_API_Settings.endpoint + "wp/v2/filter").then((response) => {
      if (response.data) {
        setCategories(response.data);
      }
    });
  }, []);

  // Update category when the URL changes
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const categoryParam = queryParams.get("category");
    if (categoryParam) {
      const categoryID = parseInt(categoryParam, 10);
      setActiveCategory(categoryID);
      setCategory(categoryID);
    }
  }, [location.search, setCategory]);

  // Handle category chip click
  const handleFilterClick = (filter) => {
    if (filter.id === null) {
      // If "All" is clicked, navigate without additional parameters
      setActiveCategory(null);
      setCategory(null);
      navigate(location.pathname);
    } else {
      // If another filter is clicked, update category and navigate with parameter
      setActiveCategory(filter.id);
      setCategory(filter.id);
      const queryParams = new URLSearchParams(location.search);
      queryParams.set("category", filter.id);
      navigate({
        pathname: location.pathname,
        search: queryParams.toString(),
      });
    }
  };

  function CategoryChip({ filter }) {
    return (
      <Chip
        label={he.decode(filter.name)}
        onClick={() => handleFilterClick(filter)}
        sx={{
          p: "1.5rem 0.5rem",
          m: "0.5rem 0.5rem 0 0",
          fontSize: "1rem",
          fontWeight: 600,
          borderRadius: "2rem",
          cursor: activeCategory === filter.id ? "default" : "pointer",
          backgroundColor: activeCategory === filter.id ? "#005EAA" : "#EBEBEB",
          color: activeCategory === filter.id ? "#fff" : "#000",
          "&:hover": {
            backgroundColor: "#005EAA",
            color: "#fff",
          },
        }}
      />
    );
  }

  return (
    <Box sx={{ m: "3rem 0" }}>
      <Grid container spacing={4}>
        <Grid item xs={12} md={7}>
                    {/* <CategoryChip filter={{ id: null, name: 'All' }} />
                    {categories.map((filter) => (
                        filter.name !== 'Uncategorized' && filter.name !== 'Uncategorised' ? (
                            <CategoryChip key={filter.id} filter={filter} />
                        ) : null
                    ))} */}
                </Grid>
        <Grid item xs={12} md={2}>
        {/* <Grid item xs={12} md={9}> */}
          {totalPages > 0 && (
            <Typography
              sx={{
                mt: "1rem",
                textAlign: "right",
              }}
            >
              {"Page " + page + " of " + totalPages}
            </Typography>
          )}
        </Grid>
        <Grid item xs={12} md={3}>
          <TextField
            fullWidth
            placeholder="Search Experiences"
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
              setSearchText(e.target.value);
            }}
            InputProps={{
              id: "search-field",
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon
                    sx={{
                      color: (theme) => theme.palette.green,
                    }}
                  />
                </InputAdornment>
              ),
            }}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
